const AppRoute = {
  // auth
  auth: '/auth',
  // kich hoat tai khoan
  mobileApp: '/mobile_app',
  agencyApp: '/agency_app',
  // tong quan
  manageGeneralInfo: '/manage-general-info',
  dashboardList: '/dashboard-list',
  dashboard: '/dashboard',
  agencyDashboard: '/agency-dashboard',
  saleDashboard: '/agency-dashboard/sale',
  landlordDashboard: '/agency-dashboard/landlord',
  investorDashboard: '/agency-dashboard/investor',
  groupDashboard: '/agency-dashboard/group',
  superDashboard: '/soc',
  // quan ly tram sac
  manageChargeStations: '/manage-charge-stations',
  // quan ly nhan vien
  manageStaffs: '/manage-staffs',
  manageVehicles: '/manage-vehicles',
  // quan ly dich vu
  testChargeTransaction: '/test-charge-transaction',
  managePaymentTransactions: '/manage-payment-transactions',
  chargeStationsList: '/charge-stations-list',
  // ban do tram sac
  stationMap: '/station-map',
  stationsMap: '/stations-map',
  stationsMapIframe: '/stations-map-iframe',
  // quan ly mat bang
  premisesList: '/premises',
  // hoa don tien dien
  energyBillList: '/energy-bill',
  // hang san xuat tru sac
  manageChargeBrand: '/charge-brand',
  // quan ly thiet bi
  inventoryList: '/inventory',
  // dinh gia sac dien
  valuationList: '/valuation',
  // bao tri tru sac
  chargeMaintain: '/charge-maintain',
  // lap dat tru sac
  chargeInstallation: '/charge-installation',
  // quan ly xe
  manageVehicles: '/manage-vehicles',
  vehicleList: '/vehicle',
  // quan ly the rfid
  rfidList: '/rfid',
  // quan ly ma dinh danh xe
  identifierList: '/evcc-identifier',
  // quan ly hang xe
  manageVehicleBrand: '/vehicle-brand',
  manageVehicleModel: '/vehicle-model',
  // quan ly phien sac
  chargeTransactionList: '/charge-transaction',
  // quan ly khach hang
  customerList: '/customer',
  customerTopUpHistory: '/customer-topup',
  // quan ly dai ly
  manageDealership: '/manage-dealership',
  saleList: '/sale',
  // lich su giao dich
  managePaymentTransactions: '/manage-payment-transactions',
  commissionTransactionList: '/commission-transaction',
  withdrawTransactionList: '/withdraw-transaction',
  agencyWithdrawRequest: '/agency-withdraw-request',
  // quan ly ndt va chu mat bang
  managePartners: '/manage-partners',
  // nha dau tu htkd
  groupsList: '/groups',
  groupList: '/group',
  investmentPackList: '/investment-pack',
  // nha dau tu nhuong quyen
  investorsList: '/investors',
  investorList: '/investor',
  // chu mat bang
  landlordsList: '/landlords',
  landlordList: '/landlord',
  // doi tac sac (vehicle identity partner)
  vehicleIdentityPartnerList: '/charge-identity-partner',
  // doi tac mua tru sac
  chargePointPartnersList: '/charge-point-partners',
  chargePointPartnerList: '/charge-point-partner',
  // bao cao doi soat
  reconciliationReport: '/reconciliation-report',
  saleReport: '/reconciliation-report/sale',
  investorReport: '/reconciliation-report/investor',
  groupReport: '/reconciliation-report/group',
  landlordReport: '/reconciliation-report/landlord',

  // he thong
  manageSystem: '/manage-system',
  // quan ly don hang admin
  orderList: '/order',
  // quan ly don hang agency
  agencyOrderList: '/agency-order',
  // quan ly nhan vien
  manageStaffs: '/manage-staffs',
  staffList: '/staff',
  // thiet lap chung
  setting: '/setting',
  pushNotificationList: '/push-notification',
  systemLogList: '/system-log',
  actionLogList: '/action-log',
  insurancePackList: '/insurance-pack',
  voucherList: '/voucher',
  withdrawTransaction: '/withdraw',
  tutorialList: '/tutorial',
  generalSetting: '/general-setting',
  premiseOrderList: '/premise-order',

  // quan ly nhom quyen
  salePermissionList: '/permission-group/sale',
  partnerPermissionList: '/permission-group/partner',
  staffPermissionList: '/permission-group/staff',

  // quan ly nhan vien
  manageStaffAccounts: '/manage-staff-accounts',
  manageStaffChargingHistory: '/manage-staff-charging-history',
  // quan ly dich vu
  testChargeTransaction: '/test-charge-transaction',
  // quan ly nhiem vu
  // quan ly doi tac
  managePartner: '/manage-partner',
  // quan ly dai ly
  manageDealer: '/manage-dealer',
  // thong tin dai ly
  saleInfo: '/sale-info',
  // lich su giao dich
  transactionHistory: '/transaction-history',
  // lich su ban hang
  saleHistory: '/sale-history',
  // them don hang
  agencyAddOrder: '/agency-add-order',
  // don mua
  purchaseOrder: '/purchase-order',
  // don ban
  saleOrder: '/sale-order',
  manageInvestor: '/manage-investor',
  manageInvester: '/manage-invester',
  manageInvestorGroupSection: '/manage-investor-group-section',
  investorGroupList: '/investor-group-list',
  manageGroupPermissionInvestor: '/manage-investor-permission',
  manageGroupPermissionInvestorGroup: '/manage-investor-group-permission',
  // thong tin nha dau tu
  investorInfo: '/investor-info',
  manageLandowner: '/manage-landowner',
  landownerList: '/landowner-list',
  manageGroupPermissionLandlord: '/manage-landlord-permission',

  myAccount: '/my-account',

  // hop dong
  contractList: '/contract',

  // quybka
  agencySaleAddOrder: '/agency-sale-add-order',
  agencySaleOrderList: '/agency-sale-order-list',
  agencySaleOrderDetail: '/agency-sale-order',
  agencyContractList: '/agency-contract-list',
  agencyReconciliationList: '/agency-reconciliation-list',
  agencyConfigCommission: '/agency-config-commission',

  stationList: '/charge-station',
  pointList: '/charge-point',
  subSaleList: '/sub-sale',
  subInvestorList: '/sub-investor',
  investorsReport: '/investors-report',
  groupInfo: '/group-info',
  subGroupList: '/sub-group',
  groupPackHistory: '/group-pack-history',
  groupsReport: '/groups-report',
  landlordInfo: '/landlord-info',
  electricityPayment: '/electricity-payment',
  landlordsReport: '/landlords-report',
  poaContract: '/poa-contract',
  managePayments: '/manage-payments',

  /** MAINTAINER */
  // auth
  maintainerAuth: '/maintainer/auth',
  // kich hoat tai khoan
  maintainerApp: '/maintainer_app',
  // tong quan
  maintainerDashboard: '/maintainer/dashboard',
  // thong tin KTV
  manageMaintainer: '/manage-maintainer',
  maintainerList: '/maintainer',
  maintainerInfo: '/maintainer/profile',
  // danh sach cong viec
  manageTickets: '/manage-tickets',
  myTicket: '/maintainer/my-ticket',
  ticketList: '/maintainer/ticket',
  maintainerReport: '/maintainer/reconciliation-report',
  // tram, tru sac
  maintainerStationList: '/maintainer/charge-station',
  maintainerPointList: '/maintainer/charge-point',
  maintainerStationsMap: '/maintainer/stations-map',

  underDevelopment: '/under-development',

  /** COINVESTOR */
  coinvestorInfo: '/coinvestor-info',
  coinvestorsList: '/coinvestors',
  coinvestorList: '/coinvestor',
  coinvestorReport: '/reconciliation-report/coinvestor',
  coinvestorDashboard: '/agency-dashboard/coinvestor',

  /** FLEET */
  // thong tin doanh nghiep
  manageFleets: '/manage-fleets',
  manageFleet: '/manage-fleet',
  fleetList: '/fleet',
  fleetInfo: '/fleet-info',
  // bao cao doi soat
  fleetReport: '/reconciliation-report/fleet',
  // tong quan
  fleetDashboard: '/agency-dashboard/fleet',
  fleetTopup: '/topup',
  fleetTransaction: '/transaction',
  // quan ly tai xe
  manageDrivers: '/manage-drivers',
  driverList: '/driver',
  driverVehicleList: '/driver-vehicle',
  chargeHistoryList: '/charge-history',
  driverTopupHistory: '/driver-topup',
  fleetStationsMap: '/fleet/stations-map',

  /** VOUCHER */
  // thong tin doi tac mua voucher
  manageVoucherPartner: '/manage-voucher-partner',
  voucherPartnerList: '/voucher-partner',
  voucherPartnerInfo: '/voucher-partner-info',
  voucherBatchList: '/voucher-batch',
  voucherList: '/voucher',
  voucherPartnerVehicle: '/vehicles',
  voucherPartnerDashboard: '/agency-dashboard/voucher-partner',
};

export default AppRoute;
